const isNotEmpty = (value: object): boolean => {
  if (value && typeof value === 'object') {
    return Array.isArray(value) ? Boolean(value.length) : Boolean(Object.keys(value).length)
  }

  return false
}


export default isNotEmpty
